import { all, fork } from 'redux-saga/effects';

import { doraDataManagementSaga } from '../data-management/store/sagas';
import { doraFunctionSaga } from '../functions/store/sagas';
import { doraThirdPartySaga } from '../third-party-companies/store/sagas';
import { doraMyCompaniesSaga } from '../my-companies/store/sagas';
import { doraSupplyChainSaga } from '../supply-chain/store/sagas';
import { doraAnalyticsSaga } from '../analytics/store/sagas';
import { doraReportingSaga } from '../reporting/store/sagas';

export function* doraSaga() {
    yield all([
        fork(doraDataManagementSaga),
        fork(doraFunctionSaga),
        fork(doraThirdPartySaga),
        fork(doraMyCompaniesSaga),
        fork(doraSupplyChainSaga),
        fork(doraAnalyticsSaga),
        fork(doraReportingSaga)
    ]);
}
